// Story 10.6 — chromeless layout for the logged-out show-off pages
// (/u, /c, /d). No AppShell nav (its account-me fetch would 401 for an
// anonymous viewer); a quiet Greenhold wordmark links home.

import type { ReactNode } from "react";
import { Link } from "react-router-dom";

export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-brand-forest-900 text-brand-paper-100">
      <header className="mx-auto flex w-full max-w-5xl items-center justify-between px-6 py-4">
        <Link to="/" className="font-heading text-lg font-bold tracking-tight">
          Greenhold
        </Link>
      </header>
      <main className="mx-auto w-full max-w-5xl px-6 pb-20 pt-6">{children}</main>
    </div>
  );
}

export function PublicLoading() {
  return (
    <PublicShell>
      <p className="text-center text-sm opacity-60">Loading…</p>
    </PublicShell>
  );
}

export function PublicNotFound({
  title,
  detail,
}: {
  title: string;
  detail: string;
}) {
  return (
    <PublicShell>
      <div className="mx-auto max-w-md text-center">
        <h1 className="font-heading text-2xl font-bold">{title}</h1>
        <p className="mt-2 text-sm opacity-70">{detail}</p>
        <Link
          to="/"
          className="mt-6 inline-block text-sm font-semibold underline decoration-dotted"
        >
          Go to Greenhold →
        </Link>
      </div>
    </PublicShell>
  );
}
